import React, { useState } from 'react';
import './Contact.css';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    checkin: '',
    checkout: '',
    guests: '1',
    roomType: 'compartida',
    message: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Formulario enviado:', formData);
    alert('¡Gracias por tu reserva! Nos pondremos en contacto contigo pronto para confirmar tu estadía en KAWILA.');

    setFormData({
      name: '',
      email: '',
      phone: '',
      checkin: '',
      checkout: '',
      guests: '1',
      roomType: 'compartida',
      message: ''
    });
  };

  return (
    <section id="contacto" className="contact">
      <div className="container">
        <div className="contact-header">
          <h2 className="section-title">Reservaciones & Contacto</h2>
          <div className="title-underline"></div>
          <p className="section-subtitle">
            ¡Reserva tu estadía en KAWILA y vive una experiencia inolvidable!
          </p>
        </div>

        <div className="contact-content">
          <div className="contact-info-section">
            <h3>Información de Contacto</h3>

            <div className="contact-card">
              <div className="contact-icon">📍</div>
              <div>
                <h4>Dirección</h4>
                <p>Santa Ana, El Salvador</p>
              </div>
            </div>

            <div className="contact-card">
              <div className="contact-icon">📧</div>
              <div>
                <h4>Email</h4>
                <p>info@kawilahostel.com</p>
              </div>
            </div>

            <div className="contact-card">
              <div className="contact-icon">📱</div>
              <div>
                <h4>Teléfono / WhatsApp</h4>
                <p>+503 XXXX-XXXX</p>
              </div>
            </div>

            <div className="social-links">
              <h4>Síguenos</h4>
              <div className="social-icons">
                <a href="#" className="social-icon" title="Facebook">📘</a>
                <a href="#" className="social-icon" title="Instagram">📷</a>
                <a href="#" className="social-icon" title="Twitter">🐦</a>
                <a href="#" className="social-icon" title="TripAdvisor">✈️</a>
              </div>
            </div>

            <div className="quick-info">
              <h4>Horarios</h4>
              <div className="info-item">
                <span>Check-in:</span>
                <span>2:00 PM</span>
              </div>
              <div className="info-item">
                <span>Check-out:</span>
                <span>12:00 PM</span>
              </div>
              <div className="info-item">
                <span>Recepción:</span>
                <span>24 horas</span>
              </div>
            </div>
          </div>

          <div className="reservation-form">
            <h3>Solicitud de Reserva</h3>
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label htmlFor="name">Nombre Completo *</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  placeholder="Tu nombre"
                />
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="email">Email *</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    placeholder="tu@email.com"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="phone">Teléfono *</label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    required
                    placeholder="+503 XXXX-XXXX"
                  />
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="checkin">Check-in *</label>
                  <input
                    type="date"
                    id="checkin"
                    name="checkin"
                    value={formData.checkin}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="checkout">Check-out *</label>
                  <input
                    type="date"
                    id="checkout"
                    name="checkout"
                    value={formData.checkout}
                    onChange={handleChange}
                    required
                  />
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="guests">Número de Huéspedes *</label>
                  <select
                    id="guests"
                    name="guests"
                    value={formData.guests}
                    onChange={handleChange}
                    required
                  >
                    <option value="1">1 persona</option>
                    <option value="2">2 personas</option>
                    <option value="3">3 personas</option>
                    <option value="4">4 personas</option>
                    <option value="5">5+ personas</option>
                  </select>
                </div>

                <div className="form-group">
                  <label htmlFor="roomType">Tipo de Habitación *</label>
                  <select
                    id="roomType"
                    name="roomType"
                    value={formData.roomType}
                    onChange={handleChange}
                    required
                  >
                    <option value="compartida">Habitación Compartida</option>
                    <option value="privada">Habitación Privada</option>
                  </select>
                </div>
              </div>

              <div className="form-group">
                <label htmlFor="message">Mensaje Adicional</label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  rows="4"
                  placeholder="¿Necesitas algo especial? ¿Tienes alguna pregunta? Escríbenos aquí..."
                ></textarea>
              </div>

              <button type="submit" className="submit-btn">
                Enviar Solicitud de Reserva
              </button>
            </form>

            <p className="form-note">
              * Campos obligatorios. Te contactaremos en menos de 24 horas para confirmar tu reserva.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
